const isCountriesVisible = process.env.REACT_APP_SHOW_DEV_COUNTRIES === 'true';

const countries = [
    { code: '+1', country: 'US', name: 'United States' },
    { code: '+43', country: 'AT', name: 'Österreich' },
    { code: '+32', country: 'BE', name: 'Belgique' },
    { code: '+359', country: 'BG', name: 'България' },
    { code: '+385', country: 'HR', name: 'Hrvatska' },
    { code: '+357', country: 'CY', name: 'Κύπρος' },
    { code: '+420', country: 'CZ', name: 'Česko' },
    { code: '+45', country: 'DK', name: 'Danmark' },
    { code: '+372', country: 'EE', name: 'Eesti' },
    { code: '+358', country: 'FI', name: 'Suomi' },
    { code: '+33', country: 'FR', name: 'France' },
    { code: '+49', country: 'DE', name: 'Deutschland' },
    { code: '+30', country: 'GR', name: 'Ελλάδα' },
    { code: '+36', country: 'HU', name: 'Magyarország' },
    { code: '+353', country: 'IE', name: 'Éire' },
    { code: '+39', country: 'IT', name: 'Italia' },
    { code: '+371', country: 'LV', name: 'Latvija' },
    { code: '+370', country: 'LT', name: 'Lietuva' },
    { code: '+352', country: 'LU', name: 'Lëtzebuerg' },
    { code: '+356', country: 'MT', name: 'Malta' },
    { code: '+31', country: 'NL', name: 'Nederland' },
    { code: '+48', country: 'PL', name: 'Polska' },
    { code: '+351', country: 'PT', name: 'Portugal' },
    { code: '+40', country: 'RO', name: 'România' },
    { code: '+421', country: 'SK', name: 'Slovensko' },
    { code: '+386', country: 'SI', name: 'Slovenija' },
    { code: '+34', country: 'ES', name: 'España' },
    { code: '+46', country: 'SE', name: 'Sverige' },
    { code: '+47', country: 'NO', name: 'Norge' },
    { code: '+44', country: 'GB', name: 'Great Britain' },
    { code: '+41', country: 'CH', name: 'Schweiz' },
    { code: '+354', country: 'IS', name: 'Ísland' }
  ].sort((a, b) => a.name.localeCompare(b.name));

  if(isCountriesVisible) {
    countries.push({ code: '+385', country: 'HR', name: 'Hrvatska' })
    countries.push({ code: '+387', country: 'BA', name: 'Bosna i Hercegovina' })
  }

  export default countries;